import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';


/**
 * APIL Url: ADAC.Internet.Core.Models.Strukturdaten.Row
 * einzelne Zeile im Absatz
 * Endpoints: /api/v2/versicherungen/fahrrad/v2/schaden
 */
export class RowApi extends BaseApiModel {
	constructor(initialProperties?: Partial<RowApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected name: string;
	/**
	 * Description: Label des Eintrags
	 * APIL Type: string
	 */
	get Name(): string {
		return this.name;
	}

	/**
	 * Description: Label des Eintrags
	 * APIL Type: string
	 */
	set Name(value: string) {
		this.name = value;
	}

	protected value: string;
	/**
	 * Description: einzelner Inhalt
	 * APIL Type: string
	 */
	get Value(): string {
		return this.value;
	}

	/**
	 * Description: einzelner Inhalt
	 * APIL Type: string
	 */
	set Value(value: string) {
		this.value = value;
	}

	protected values: string[];
	/**
	 * Description: Liste von Inhalten für einen Eintrag. z.B. Liste von Beträgen und Dokumenten
	 * APIL Type: Collection<string>
	 */
	get Values(): string[] {
		return this.values;
	}

	/**
	 * Description: Liste von Inhalten für einen Eintrag. z.B. Liste von Beträgen und Dokumenten
	 * APIL Type: Collection<string>
	 */
	set Values(value: string[]) {
		this.values = value;
	}

	protected asBulletpoints: boolean;
	/**
	 * Description: Liste der Beiträge als Listenpunkt darstellen
	 * APIL Type: boolean
	 */
	get AsBulletpoints(): boolean {
		return this.asBulletpoints;
	}

	/**
	 * Description: Liste der Beiträge als Listenpunkt darstellen
	 * APIL Type: boolean
	 */
	set AsBulletpoints(value: boolean) {
		this.asBulletpoints = value;
	}

	protected startIndex: number;
	/**
	 * Description: Start Index der Listenpunkte
	 * APIL Type: int32
	 */
	get StartIndex(): number {
		return this.startIndex;
	}

	/**
	 * Description: Start Index der Listenpunkte
	 * APIL Type: int32
	 */
	set StartIndex(value: number) {
		this.startIndex = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): RowApi {
		return AppUtils.Helper.createFromMap(dataObject, RowApi, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Name = this.name;
		result.Value = this.value;
		result.Values = this.values;
		result.AsBulletpoints = this.asBulletpoints;
		result.StartIndex = this.startIndex;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}